import Vue from 'vue';

export default (filter, cb) => {
  Vue.$http
    .get('CustomerGroups', { params: filter })
    .then((response) => {
      cb(null, response);
    })
    .catch((error) => {
      cb(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/group/get.js